import { BIToggleButton } from '@pulsepointinc/bi-components';
import styled from 'styled-components';

export const StyledBIToggleButtons = styled(BIToggleButton)`
  flex: 1;
  width: 100%;
`;
